import { IEvent } from "@Interfaces";
import { GST_STATUS } from "@Utils";

export const evaluateIsGSTIncluded = ({
    eventData,
}: {
    eventData: IEvent.IEventData;
}) => {
    const gstState = eventData?.gst_state || GST_STATUS.INAPPLICABLE;
    const isGSTIncluded: boolean = [
        GST_STATUS.INCLUSIVE,
        GST_STATUS.EXCLUSIVE,
    ].includes(gstState);
    return isGSTIncluded;
};
